import { render } from "./App.vue?vue&type=template&id=278278e4"
const script = {}

import "./App.vue?vue&type=style&index=0&id=278278e4&lang=scss"

import exportComponent from "/var/www/probusandcar.com/mobile_probus_app/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__